import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Card, Pagination, CardHeader, CardTitle } from '@otcmarketsgroup/otcm-ui-lib';
import { FiList, FiBook } from 'react-icons/fi';
import { FaChevronDown } from 'react-icons/fa';
import { getMarketReports } from '../../api/marketReports';
import { getEmailList } from '../../api/user';
import { storage } from '../../constants';
import ShareReport from '../../container/ShareReport';
import ErrorPage from '../ErrorPage';
import { withRouter } from '../../components/WithRouter';
import Loading from '../../components/Loading';
import MarketReportTable from '../../components/MarketReportTable';
import EmailList from '../../components/EmailList';
import styles from './MarketReports.module.scss';

const RESULTS_PER_PAGE = 25;


const MarketReports = ({ params }) => {
    const [marketReportData, setMarketReportData] = useState(null);
    const [marketReportDataSet, setMarketReportDataSet] = useState(null);
    const [marketReportParams, setMarketReportParams] = useState(null);
    const [reloading, setReloading] = useState(false);
    const [marketReportError, setMarketReportError] = useState('');
    const [showErrorPage, setErrorPage] = useState(false);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [shareReport, setShareReport] = useState(null);
    const [emailList, setEmailList] = useState(null);
    const [emailListError, setEmailListError] = useState(false);
    const [isEmailSectionVisible, setEmailSectionVisible] = useState(false);
    const symbol = params?.symbol;
    const marketReportsLoaded = !!marketReportData;
    const totalResults = marketReportData?.totalResults;
    const displayPagination = totalResults > RESULTS_PER_PAGE;

    useEffect(() => {
        setEmailListError(false);

        window.sessionStorage.setItem(storage.SYMBOL, symbol);

        setMarketReportParams({ 'pageSize': RESULTS_PER_PAGE, 'page': 1 });

        getEmailList(symbol)
            .then(data => {
                setEmailList(data);
            })
            .catch(error => {
                console.error(`Failed Securities call: `, error);
                setEmailListError(true);
            });

    }, [symbol]);

    useEffect(() => {
        if (marketReportParams !== undefined && marketReportParams !== null) loadMarketReports();
    }, [marketReportParams]);

    const loadMarketReports = _ => {
        if (marketReportsLoaded) setReloading(true);

        getMarketReports(symbol, marketReportParams)
            .then(data => {
                const newData = data.results;
                const isPageCall = marketReportParams?.page;

                setReloading(false);
                setMarketReportData(data);
                setMarketReportDataSet(newData);
            })
            .catch(error => {
                if (error?.response?.status === 403) {
                    setReloading(false);
                    setErrorPage(true);
                    return;
                }

                setReloading(false);
                setMarketReportError('Error: Data not available at this time');
            });
    };

    const handleShareClick = report => {
        setShareReport(report);
        setDialogVisible(true);
    };

    const handlePageChange = (event, newPage) => {
        setMarketReportParams(prevParams => ({
            ...prevParams,
            page: newPage,
        }));
    };

    const toggleEmailSection = () => {
        setEmailSectionVisible(prevState => !prevState);
    };

    const handleCloseDialog = () => {
        setDialogVisible(false);
    };

    return showErrorPage ? <ErrorPage /> : <div className={styles.container}>
        <Box display='flex' flexDirection='column' gap={2}>
            <Card>
                <CardHeader gutterBottom={false}>
                    <CardTitle icon={<FiList />}>
                        Email Distribution List
                    </CardTitle>
                    <Button variant='text' endIcon={<FaChevronDown />} onClick={toggleEmailSection}>
                        {isEmailSectionVisible ? 'Hide list' : 'Show list'}
                    </Button>
                </CardHeader>
                <div className={`${styles.emailsClosed} ${isEmailSectionVisible ? styles.emailsOpen : ''}`}>
                    <EmailList lists={emailList} error={emailListError} />
                </div>
            </Card>
            <Card>
                <CardHeader>
                    <CardTitle icon={<FiBook />}>
                        OTC Market Report
                    </CardTitle>
                </CardHeader>
                <div>
                    <Loading loaded={marketReportsLoaded} reloading={reloading} error={marketReportError}>
                        <MarketReportTable
                            data={marketReportDataSet}
                            symbol={symbol}
                            params={marketReportParams}
                            onShareClick={handleShareClick} />
                        {displayPagination && <Box display='flex' justifyContent='flex-end' pt={2}>
                            <Pagination
                                count={marketReportData?.totalPages}
                                onPageChange={handlePageChange}
                                page={marketReportData?.currentPage || 1}
                            />
                        </Box>}
                    </Loading>
                </div>
                <ShareReport dialogVisible={dialogVisible} onClose={handleCloseDialog} report={shareReport} />
            </Card>
        </Box>
    </div>;
};


MarketReports.propTypes = {
    params: PropTypes.object,
};

export default withRouter(MarketReports);